import dayjs, { Dayjs } from "dayjs"
import moment from "moment"

export const onlyDateFormat = "DD.MM.yyyy"
export const dateWithoutSecondsFormat = "DD.MM.yyyy HH:mm"
export const dateTimeFormat = "DD.MM.yyyy HH:mm:ss"

export const formatDate = (date: string | Date, format: string = onlyDateFormat) => {
  return formatDateTime(date.toString(), format)
}

export const formatTime = (date: string | Date, format: string = "HH:mm") => {
  return formatDateTime(date.toString(), format)
}

export const formatDateTime = (date: string, format: string) => {
  let dateConverted = new Date(date)
  return dateConverted && dateConverted.getFullYear() > 1970 ? moment(new Date(date)).format(format) : "-"
}

export const serializeRangeDayjs = (range: Dayjs[]): string => {
  return `${range[0]}||${range[1]}`
}

export const deserializeRangeDayjs = (value: string): Dayjs[] => {
  return [
    ...value.split("||").map((date) => dayjs(date))
  ]
}
